import { Image } from 'expo-image';
import { Platform, Pressable } from 'react-native';
import { Tooltip } from 'react-native-paper';

import { infoIcon } from '@/assets/images/icons';
import { useInfoModal } from '@/contexts/infoModalContext';

import TooltipWeb from './TooltipWeb';

interface InfoButtonProps {
  title: string;
  message?: string;
  size?: number;
  type?: 'modal' | 'normal';
  icon?: any;
}

const InfoButton = ({ title, message, size = 24, type = 'normal', icon = infoIcon }: InfoButtonProps) => {
  const { showInfo } = useInfoModal();

  const handleModalTooltipPress = () => {
    showInfo({
      type: 'tooltip',
      title: title,
      message: message
    });
  };

  if (type === 'modal' && message) {
    return (
      <Pressable onPress={handleModalTooltipPress}>
        <Image source={icon} style={{ borderRadius: size / 2, height: size, width: size }} contentFit="contain" />
      </Pressable>
    );
  }

  if (Platform.OS === 'web') {
    return (
      <TooltipWeb title={message ?? title} onClick={type === 'modal' && message ? handleModalTooltipPress : undefined}>
        <Image source={icon} style={{ borderRadius: size / 2, height: size, width: size }} contentFit="contain" />
      </TooltipWeb>
    );
  }

  //Base Tooltip
  return (
    <Tooltip enterTouchDelay={100} title={title}>
      <Image source={icon} style={{ borderRadius: size / 2, height: size, width: size }} contentFit="contain" />
    </Tooltip>
  );
};

export default InfoButton;
